var getScaleValueBySize = function (size) {
    switch (size) {
        case 'small': return 0.89;
        case 'medium': return 0.9;
        case 'large': return 0.83;
    }
};
export default getScaleValueBySize;
